module.exports = __webpack_public_path__ + "static/img/icon-plus.778c144.png";